module.exports = __webpack_public_path__ + "img/workContents01_pc_03.cad0ed11.png";